export default "__VITE_ASSET__BgZNPjgX__"